export default __webpack_public_path__ + "static/media/gallery_00.de161ef8.jpg";